const KeyCodeConstants = {
    DOWN_ARROW: 40,
    ENTER: 13,
    TAB: 9,
    UP_ARROW: 38
};

export default KeyCodeConstants;